export class Configuration {
    public AwsRegion = '';
    public AccessKey = '';
    public SecretKey = '';
    public S3Acl = '';
    public Bucket = '';
}